import { render, staticRenderFns } from "./TaskDetailBasics.vue?vue&type=template&id=7eaae3a9"
import script from "./TaskDetailBasics.vue?vue&type=script&lang=js"
export * from "./TaskDetailBasics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports